import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { deleteAccount, clearAllTokens } from '../../api/services/authService';

const getDashboardPath = (pathname) => {
  if (pathname.startsWith('/landlord')) return '/landlord';
  if (pathname.startsWith('/airbnb-host')) return '/airbnb-host';
  if (pathname.startsWith('/agent')) return '/agent';
  if (pathname.startsWith('/tenant')) return '/tenant';
  if (pathname.startsWith('/system-admin')) return '/system-admin';
  return '/';
};

const DeleteAccountPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const dashboardPath = getDashboardPath(location.pathname);

  const handleCancel = () => {
    navigate(dashboardPath, { replace: true });
  };

  const handleDelete = async () => {
    setLoading(true);
    setError('');

    try {
      await deleteAccount();
      clearAllTokens();
      navigate('/login', { replace: true });
    } catch (deleteError) {
      setError(deleteError?.message || 'Failed to delete account. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 80px)',
        padding: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        background: '#F5F7FB',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '640px',
          background: '#ffffff',
          borderRadius: '20px',
          padding: '36px',
          boxShadow: '0 24px 80px rgba(2, 35, 106, 0.12)',
        }}
      >
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ margin: 0, fontSize: '32px', color: '#02236A' }}>Delete Account</h1>
          <p style={{ marginTop: '12px', fontSize: '16px', color: '#475569', lineHeight: 1.75 }}>
            This page allows you to delete your TenantScore account permanently. Once deleted, you will be signed out and you will not be able to sign in again.
          </p>
        </div>

        <div
          style={{
            background: '#FEF2F2',
            border: '1px solid #FECACA',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px',
          }}
        >
          <p style={{ margin: 0, fontSize: '16px', color: '#B91C1C', fontWeight: 600 }}>
            Warning: this action cannot be undone.
          </p>
          <p style={{ marginTop: '10px', fontSize: '14px', color: '#475569' }}>
            Your account will be marked as deleted and your profile information will no longer be accessible.
          </p>
        </div>

        {error && (
          <div
            style={{
              background: '#FEE2E2',
              color: '#B91C1C',
              borderRadius: '14px',
              padding: '16px',
              marginBottom: '24px',
            }}
          >
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={handleCancel}
            style={{
              background: '#E2E8F0',
              border: 'none',
              borderRadius: '12px',
              color: '#102A43',
              padding: '14px 22px',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 600,
            }}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDelete}
            style={{
              background: '#DC2626',
              border: 'none',
              borderRadius: '12px',
              color: '#ffffff',
              padding: '14px 22px',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 700,
            }}
            disabled={loading}
          >
            {loading ? 'Deleting account…' : 'Delete account'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
